import ListFieldHint from "./ListFieldHint";
import ListFieldTitle from "./ListFieldTitle";
import RecordPicker from "./RecordPicker";

function ListRecordField({ field, value, onChange }) {
  return (
    <div>
      <ListFieldTitle field={field} />
      <RecordPicker
        model={field.model}
        domain={field.domain}
        multiple={field.type === "records"}
        value={value}
        onChange={(next) => onChange(field.name, next)}
      />
      <ListFieldHint id={field.hint} />
    </div>
  );
}

export default ListRecordField;
